import {createStore, withProps} from '@ngneat/elf';

export interface AuthState {
  existEmail: string;
  token: string;
  refreshToken: string;
}

export function createInitialState(): AuthState {
  return {
    existEmail: null,
    token: null,
    refreshToken: null,
  };
}

export const authStore = createStore({name: 'auth'}, withProps<AuthState>(createInitialState()));
